import { render } from "./CustomNodeDeletePage.vue?vue&type=template&id=59d004cc"
import script from "./CustomNodeDeletePage.vue?vue&type=script&lang=js"
export * from "./CustomNodeDeletePage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__